// Links into the Print Center from other screens (restock, receiving, product
// creation). Only stable receipt ids travel in the URL; the Print Center
// resolves them on the server and recomputes what still needs labels.

export const PRINT_CENTER_PATH = "/admin/print-center";
export const RECEIPT_PARAM = "receipt";

export const printCenterReceiptPath = (receiptIds) => {
  const ids = [...new Set((receiptIds || []).map(Number).filter((id) => Number.isInteger(id) && id > 0))];
  return ids.length ? `${PRINT_CENTER_PATH}?${RECEIPT_PARAM}=${ids.join(",")}` : PRINT_CENTER_PATH;
};

/** Receipt ids from `?receipt=12,13` (invalid or duplicate values ignored, at most 50). */
export const parseReceiptParam = (value) =>
  [
    ...new Set(
      String(value || "")
        .split(",")
        .map((part) => Number(part.trim()))
        .filter((id) => Number.isInteger(id) && id > 0)
    ),
  ].slice(0, 50);
